import { ISeriesPrimitivePaneRenderer } from 'lightweight-charts'
import DrawingPaneAxisRenderer from './drawing.paneAxisRenderer'
import DrawingPaneView, { DrawingPaneViewOptions } from './drawing.paneView'

export type DrawingPaneAxisViewOptions = DrawingPaneViewOptions & {
    horizontal: boolean;
}

class DrawingPaneAxisView extends DrawingPaneView {
    horizontal: boolean

    constructor(options: DrawingPaneAxisViewOptions) {
        super(options)
        this.horizontal = options.horizontal
    }

    renderer(): ISeriesPrimitivePaneRenderer | null {
        return new DrawingPaneAxisRenderer({
            drawing: this.drawing,
            id: this.id,
            horizontal: this.horizontal
        })
    }
}


export default DrawingPaneAxisView